import SubjectsSection from "@/components/SubjectsSection";

const SubjectsPage = () => {
    return (
        <main className="container mx-auto px-4">
            {/* Reuse the rewritten SubjectsSection which is already perfect */}
            <SubjectsSection />
        </main>
    );
};

export default SubjectsPage;
